import { BRIDGE_STATIONS } from "../shared/corridor";
import type { PublicBridge, PublicSnapshot } from "../shared/contracts";

export function unavailableSnapshot(now = new Date()): PublicSnapshot {
  const timestamp = now.toISOString();
  return {
    version: "v1",
    dataMode: "live",
    sequence: 0,
    generatedAt: timestamp,
    experience: { livingRiverEnabled: false },
    forecast: {
      state: "unavailable",
      horizonMinutes: 30,
      freshness: "unknown",
      updatedAt: timestamp,
      openingWindow: null,
      confidencePercent: null,
      reason: null,
    },
    weather: {
      condition: "unknown",
      conditionsValidAt: null,
      isDay: null,
      temperatureF: null,
      precipitationRateMmPerHour: null,
      cloudCoverPercent: null,
      cloudCoverLowPercent: null,
      cloudCoverMidPercent: null,
      cloudCoverHighPercent: null,
      windSpeedMph: null,
      windDirectionDegrees: null,
      windGustMph: null,
      directNormalIrradianceWm2: null,
      diffuseRadiationWm2: null,
      state: "unavailable",
      windowStartsAt: null,
      windowEndsAt: null,
      amountMm: null,
      rainChancePercent: null,
      freshness: "unknown",
      updatedAt: null,
    },
    roadTraffic: {
      source: "modeled",
      condition: "unavailable",
      congestionPercent: null,
      speedMph: null,
      freeFlowSpeedMph: null,
      observedSegments: 0,
      roads: [],
      freshness: "unknown",
      updatedAt: null,
    },
    bridges: BRIDGE_STATIONS.map((station) => ({
      id: station.id,
      name: station.name,
      shortName: station.shortName,
      state: "unknown",
      freshness: "unknown",
      observedAt: null,
      lastConfirmedAt: null,
    })),
    vesselActivity: {
      activeTracks: 0,
      approachingBridge: 0,
      status: "unavailable",
      issue: null,
      freshness: "unknown",
      updatedAt: null,
    },
    vessels: [],
    vesselGroups: [],
  };
}

/** Keeps the public diagram complete even during a partial upstream update. */
export function completeBridgeList(bridges: readonly PublicBridge[]): PublicBridge[] {
  return BRIDGE_STATIONS.map((station) => {
    const bridge = bridges.find((candidate) => candidate.id === station.id);
    return bridge ?? {
      id: station.id,
      name: station.name,
      shortName: station.shortName,
      state: "unknown",
      freshness: "unknown",
      observedAt: null,
      lastConfirmedAt: null,
    };
  });
}
